import { makeActionCreator } from '../../../utilities'
import { FluidsConstants } from './fluids.constants'

export const setTransportType = makeActionCreator(FluidsConstants.SET_TRANSPORT_TYPE, 'transportType')
export const setBeforeIntakeCrys = makeActionCreator(FluidsConstants.SET_BEFORE_INTAKE_CRYS, 'beforeIntakeCrys')
export const setBeforeIntakeColl = makeActionCreator(FluidsConstants.SET_BEFORE_INTAKE_COLL, 'beforeIntakeColl')
export const setBeforeIntakeOther = makeActionCreator(FluidsConstants.SET_BEFORE_INTAKE_OTHER, 'beforeIntakeOther')
export const setBeforeIntakeFeedings = makeActionCreator(
  FluidsConstants.SET_BEFORE_INTAKE_FEEDINGS,
  'beforeIntakeFeedings'
)
export const setBeforeOutputEbl = makeActionCreator(FluidsConstants.SET_BEFORE_OUTPUT_EBL, 'beforeOutputEbl')
export const setBeforeOutputUo = makeActionCreator(FluidsConstants.SET_BEFORE_OUTPUT_UO, 'beforeOutputUo')
export const setBeforeOutputOther = makeActionCreator(FluidsConstants.SET_BEFORE_OUTPUT_OTHER, 'beforeOutputOther')
export const setBeforeOutputBm = makeActionCreator(FluidsConstants.SET_BEFORE_OUTPUT_BM, 'beforeOutputBm')
export const setDuringIntakeCrys = makeActionCreator(FluidsConstants.SET_DURING_INTAKE_CRYS, 'duringIntakeCrys')
export const setDuringIntakeColl = makeActionCreator(FluidsConstants.SET_DURING_INTAKE_COLL, 'duringIntakeColl')
export const setDuringIntakeOther = makeActionCreator(FluidsConstants.SET_DURING_INTAKE_OTHER, 'duringIntakeOther')
export const setDuringIntakeFeedings = makeActionCreator(
  FluidsConstants.SET_DURING_INTAKE_FEEDINGS,
  'duringIntakeFeedings'
)
export const setDuringOutputEbl = makeActionCreator(FluidsConstants.SET_DURING_OUTPUT_EBL, 'duringOutputEbl')
export const setDuringOutputUo = makeActionCreator(FluidsConstants.SET_DURING_OUTPUT_UO, 'duringOutputUo')
export const setDuringOutputOther = makeActionCreator(FluidsConstants.SET_DURING_OUTPUT_OTHER, 'duringOutputOther')
export const setDuringOutputBm = makeActionCreator(FluidsConstants.SET_DURING_OUTPUT_BM, 'duringOutputBm')
export const setIsNeonatal = makeActionCreator(FluidsConstants.SET_IS_NEONATAL, 'isNeonatal')
export const calculateIsNeonatalAction = makeActionCreator(FluidsConstants.CALCULATE_IS_NEONATAL)
export const saveFluids = makeActionCreator(FluidsConstants.SAVE_FLUIDS)
export const setFluidsState = makeActionCreator(FluidsConstants.SET_FLUIDS_STATE, 'fluids')
export const resetFluidsState = makeActionCreator(FluidsConstants.RESET_FLUIDS_STATE)
export const clearFluidsFields = makeActionCreator(FluidsConstants.CLEAR_FLUIDS_FIELDS)
export const setCustomFluidValue = makeActionCreator(
  FluidsConstants.SET_CUSTOM_FLUID_VALUE,
  'value',
  'optionId',
  'transportPeriod'
)
